<template>
  <div>
    <Header></Header>

    <div class="ui container">
      <div v-if="this.loading">
        <div class="ui active inverted dimmer">
          <div class="ui text loader">Loading</div>
        </div>
        <p></p>
      </div>
      <table v-else ref="categoriesTable" id="example" class="ui celled table">
        <thead>
          <tr>
            <th>#</th>
            <th>Category</th>
            <th>Parent Category</th>
            <th>Las Modified Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr v-bind:key="key" v-for="(category, key) in this.categories">
            <td>{{ key + 1 }}</td>
            <td>{{ category.catg_name }}</td>
            <td>{{ category.parent_catg_id }}</td>
            <td>{{ category.last_modified }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "../components/Header";
const dt = null;
export default {
  name: "categories",
  components: { Header },
  data() {
    return {
      categories: [],
      loading: true
    };
  },
  methods: {
    async getCategories() {
      let response = await this.axios.post(
        this.$store.state.apiUrl + "Read/categories.php",
        {
          token: localStorage.getItem("token")
        }
      );
      this.categories = response.data.data;
      this.loading = false;
    }
  },
  beforeMount() {
    this.getCategories();
  },
  mounted() {
    this.dt = $(this.$refs.categoriesTable).DataTable();
  },
  watch: {
    categories(val) {
      this.dt.destroy();
      this.$nextTick(() => {
        this.dt = $(this.$refs.categoriesTable).DataTable();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Categories.vue